import React, { useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./StaffClientsModal.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CommonMultiSelect, CommonSelect, CstmPagination, RequiredFieldAstrick } from "components/Common/Common";
import { useGetStaffClientsListQuery } from "store/services/staff";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { MANAGE_STAFF, MANAGE_STAFF_TASK_LIST } from "config/paths";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import { useCreateRecommendationTemplateMutation, useRemoveRecommendationTemplateMutation, useUpdateRecommendationsTemplateMutation, useUpdateStrategyTemplateMutation } from "store/services/clients/reports-v2/recommendationTemplates";
import validationSchema from "./index.schema";
import AppInputField from "components/shared/FormComponents/AppInputField";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import LoadingButton from "components/shared/LoadingButton";
import AppSelectField from "components/shared/FormComponents/AppSelectField";
import { REPORTS_V2 } from "config/constants";
import { successMessageToast } from "helpers/common";

const RecommendationsModal = ({ show, setShow, currentEntry }) => {

    const [createTemplate] = useCreateRecommendationTemplateMutation();
    const [updateTemplate] = useUpdateRecommendationsTemplateMutation();

    const initialValues = useMemo(() => {
        return {
            title: currentEntry?.title || "",
            answers: currentEntry?.answers || ""
        }
    }, [currentEntry]);

    const handleSubmit = async (values) => {
        const body = {
            ...values
            // assesment_type: 0
        }
        try {
            const result = currentEntry?.id ? await updateTemplate({ id: currentEntry?.id, clientType: null, values: body }).unwrap() : await createTemplate({ clientType: null, values: body }).unwrap();
            successMessageToast(result?.message);
            setShow(false)
        } catch (err) {
            console.error("Error saving recommendation template", err);
        }
    }



    const handlePopup = () => setShow(false)

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Header>
                    <div >
                        <Button
                            onClick={handlePopup}
                            className="cursor-pointer border-0 p-0 position-absolute"
                            variant="transparent"
                            style={{ right: 15, top: 10, cursor: "pointer", lineHeight: "0", verticalAlign: "middle" }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    <div className="d-flex align-items-center justify-content-between  w-100">
                        <h6 style={{ fontSize: "18px" }} className="m-0 fw-bold themeBlue">Recommendation Template</h6>
                    </div>
                </Modal.Header>
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                        enableReinitialize
                    >
                        {({
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                            errors,
                            values,
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <div className="">
                                    <Row >
                                        {console.log('errors', errors)}
                                        <Col md="12" className="my-2">
                                            <label
                                                htmlFor=""
                                                className="form-label themeBlue fw-bold mb-0"
                                            >
                                                Name of Recommendation
                                                <RequiredFieldAstrick />
                                            </label>
                                            <AppInputField
                                                name="title"
                                                className={`${styles.formControl} form-control`}
                                                styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                                                placeholder="Enter recommendation name"
                                            />
                                            {/* <AppInputField
                                                type="text"
                                                name="title"
                                                placeholder="Enter recommendation name"
                                                className={`${styles.formControl} form-control`}
                                                maxLength={50}
                                            /> */}
                                        </Col>
                                        <Col md="12" className="my-2">
                                            <label
                                                htmlFor=""
                                                className="discharge-screen-label mt-0"
                                            >
                                                Description
                                                <RequiredFieldAstrick />
                                            </label>
                                            <div className="editor-paren-v2">
                                                <CustomEditor style={{ borderRadius: 0 }} name={`answers`} />
                                            </div>
                                            {/* <CKEditorField
                        items={[
                          'bold',
                          'italic',
                          'underline',
                          'alignment',
                          '|',
                          'bulletedList',
                          'numberedList',
                        ]}
                        value={values?.answers}
                        handleChange={(event, editor) => {
                          setFieldValue(`answers`, editor?.getcurrentEntry());
                        }}
                      /> */}
                                        </Col>
                                    </Row>
                                </div>
                                <div className="btnWrpper mt-2 text-end d-flex justify-content-end">
                                    <LoadingButton
                                        type="submit"
                                        className="commonBtn"
                                        isLoading={isSubmitting}
                                    >
                                        Save to Templates
                                    </LoadingButton>
                                </div>
                            </Form>
                        )}
                    </Formik>


                </Modal.Body>
            </Modal >
        </>
    );
};

export default RecommendationsModal;